export const SIMILAR_SURVEYS_SEARCH_COMPLETE_MESSAGE =
  'Similar survey search is complete.';

export const SIMILAR_SURVEYS_FAILURE_MESSAGE = 'Failed to load similar surveys';
